export default "__VITE_ASSET__ByhBu8r8__"